import { render, staticRenderFns } from "./EditBankModal.vue?vue&type=template&id=43645b0c&scoped=true"
import script from "./EditBankModal.vue?vue&type=script&lang=js"
export * from "./EditBankModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43645b0c",
  null
  
)

export default component.exports